const ReceiptDivider = () => (
    <div className="flex items-center space-x-1 my-2">
        <div className="flex-1 border-t-2 border-dotted border-gray-300"></div>
    </div>
);

export default ReceiptDivider;